module.exports = __webpack_public_path__ + "img/to_do_two.bc402e56.png";